export const siteSettings = {
  name: "Flux Bridge",
  link: "https://fluxbridgeuk.live",
  email: "support@fluxbridgeuk.live",
  appLink: "https://app.fluxbridgeuk.live",
};
